import { render, staticRenderFns } from "./MpMaterialList.vue?vue&type=template&id=c578dde2&"
import script from "./MpMaterialList.vue?vue&type=script&lang=js&"
export * from "./MpMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./MpMaterialList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports